import React, { FC, useState } from 'react';
import { Pays } from '../../../interfaces-base';
import { Btn } from '@dp/product-customizer-components';
import Icons from '../../mon-compte/Icons';
import { getCountryFlagUrl } from '../utils/form.util';
import { TranslationProps } from '../../../contexts/TranslationContext';
import './css/select-country.css';

interface Props {
  items: Pays[];
  value: number;
  onChange?: (value: Pays) => void;
}

const SelectCountry: FC<Props & TranslationProps> = ({ textsContent, items, value, onChange }): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false);
  const [canClose, setCanClose] = useState<boolean>(true);

  const formatLabel = (country: Pays): string => {
    return country.Libelle.toUpperCase() === 'FRANCE' ? 'France métropolitaine' : country.Libelle;
  };

  const handleClickCountry = (country: Pays): void => {
    onChange?.(country);
    setOpen(false);
  };

  const itemSelected = items.find(item => item.idPays === value);
  return (
    <div className="fa-select-country-container" onBlur={() => canClose && setOpen(false)}>
      <Btn
        className="fa-select-country"
        aspect="new-outline"
        onClick={() => setOpen(!open)}
      >
        {itemSelected && (
          <div>
            <img src={getCountryFlagUrl(itemSelected)} width="24" height="24"  />
            <span>{formatLabel(itemSelected)}</span>
          </div>
        ) || (
          <span>{textsContent?.['SHIPPING_FORM_DEFAULT_SELECT_COUNTRY']}</span>
        )}
        <Icons icon="arrow_drop_down" size={24} />
      </Btn>
      <div
        className={`fa-countries-list ${open && 'open'}`}
        onMouseEnter={() => setCanClose(false)}
        onMouseLeave={() => setCanClose(true)}
        onMouseDown={() => setCanClose(false)}
        onMouseUp={() => setCanClose(true)}
      >
        {items.map(item => (
          <button
            key={`fa-country-item-${item.idPays}`}
            className={`${item.idPays === value && 'selected'}`}
            onClick={() => handleClickCountry(item)}
          >
            <img src={getCountryFlagUrl(item)} width="24" height="24"  />
            <span>{formatLabel(item)}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SelectCountry
